var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 87,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 41 91 1c3-2 7 0 8 3l1 4-12 72c-1 5-5 8-9 7l-4-2-30-22a7 7 0 0 1 0-11l30-28v-1h-1L28 52l-5 1-21-7a3 3 0 0 1 0-5Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramButton);
export default __webpack_public_path__ + "static/media/telegram-button.6a7d604cab2d7c187c9bb6b4d5877523.svg";
export { ForwardRef as ReactComponent };